import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useSnackbar } from "notistack";
import { React, useEffect, useRef, useState } from "react";
// import { useNavigate } from 'react-router-dom';
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Radio from "@mui/material/Radio";
import queryString from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import { api_Routes } from "../../api_Routes";
import Crtypto from "../../Assets/crypto.svg";
import Payeer from "../../Assets/Payeer.png";
import { Helper } from "../../tools/Helper";

const OffersInvoiceByGuest = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { invoice_id } = queryString.parse(location.search);
  const baseApi = api_Routes.invoice.getOneOfferByGuest(invoice_id);
  const [invoice, setinvoice] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [isloading, setIsloading] = useState(true);
  const [IsloadingForBuy, setIsloadingForBuy] = useState(false);
  const [payment_method, setpayment_method] = useState("");
  const invoiceRef = useRef(null);
  useEffect(() => {
    get_invoice();
  }, []);

  // Function to handle payment method change
  const handleMethodChange = (event) => {
    setpayment_method(event.target.value);
  };

  const get_invoice = async () => {
    setIsloading(true);
    let url = baseApi;
    const { response, message } = await Helper.Get({
      url: url,
      hasToken: true,
    });
    if (response) {
      setIsloading(false);
      setinvoice({
        invoice_id: response.data.invoice_id,
        user_name: response.data.user_name,
        discount: response.data.discount || 0,
        final_price: response.data.final_price,
        custom: response.data.custom || false,
        price: response.data.price,
        panel_url: response.data.panel_url,
        created_at: response.data.created_at,
        offer_title: response.data.offer_title,
        offer_details: response.data.offer_details,
        offer_discount: response.data.offer_discount,
        offer_total_price: response.data.offer_total_price,
      });
    } else {
    }
    setIsloading(false);
  };
  const printInvoice = () => {
    if (!invoiceRef.current) return;

    const printContent = invoiceRef.current.innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload(); // Reload to restore the app state
  };

  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        const { response } = await Helper.Get({
          url: api_Routes.invoice.getOneByGuest(invoice_id),
          hasToken: true,
        });

        if (response?.data?.status_payment === "PAID") {
          enqueueSnackbar("Payment completed successfully!", {
            variant: "success",
          });
          navigate("/payment/success");
        }
      } catch (error) {
        console.error("Error checking payment status:", error);
      }
    };

    const interval = setInterval(checkPaymentStatus, 10000); // Check every 5 seconds
    return () => clearInterval(interval);
  }, [invoice_id, enqueueSnackbar, navigate]);

  const handleSubmit = async () => {
    // Ensure the user selected a payment method
    if (!payment_method) {
      enqueueSnackbar("Please select a payment method.", {
        variant: "warning",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      return;
    }

    setIsloadingForBuy(true);

    const { response, message } = await Helper.Post({
      url: api_Routes.invoice.payByGuest,
      data: {
        payment_method: payment_method,
        invoice_id: invoice_id,
      },
      hasToken: true,
    });

    if (response) {
      enqueueSnackbar(message, {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      const redirectUrl = response.data;
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        console.error("Redirect URL is missing in the response");
      }
    } else {
      let errorMessage = "";
      if (typeof message === "string") {
        errorMessage = message;
      } else if (typeof message === "object") {
        errorMessage = Object.values(message).flat().join(", ");
      }
      enqueueSnackbar(errorMessage, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    }
    setIsloadingForBuy(false);
  };

  return (
    <>
      {isloading ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            background: "white",
            animation: "fadeIn 1s",
            "@keyframes fadeIn": {
              from: { opacity: 0 },
              to: { opacity: 1 },
            },
          }}
        >
          <CircularProgress
            sx={{ color: "blue", animation: "spinner 1.5s linear infinite" }}
          />
          {/* <Typography
                        sx={{
                            color: "blue",
                            marginTop: "20px",
                            fontSize: "18px",
                            fontWeight: "500",
                            animation: "fadeText 3s ease-in-out infinite",
                            '@keyframes fadeText': {
                                '0%, 100%': { opacity: 0.5 },
                                '50%': { opacity: 1 },
                            },
                        }}
                    >
                        Loading offer details...
                    </Typography> */}
        </Box>
      ) : (
        <Container
          sx={{
            marginBlock: "30px",
            "@media (min-width: 1200px)": {
              maxWidth: "1400px",
            },
            animation: "slideIn 0.7s ease",
            "@keyframes slideIn": {
              from: { transform: "translateY(20px)", opacity: 0 },
              to: { transform: "translateY(0)", opacity: 1 },
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <Typography
              sx={{
                color: "#474747",
                fontSize: { xs: "20px", sm: "25px", md: "40px" },
                lineHeight: "40px",
                fontWeight: "700",
              }}
            >
              Orders Invoice
            </Typography>
          </Box>
          <Box
            sx={{
              background: "#F1F5FD",
              marginTop: "50px",
              padding: { xs: "20px 20px 10px 20px", md: "50px 50px 10px 50px" },
              borderRadius: "26px",
            }}
            ref={invoiceRef}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                borderBottom: "1px solid #5F5F5F",
              }}
            >
              <Box>
                <svg
                  width="164"
                  height="49"
                  viewBox="0 0 164 49"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.8035 17.8308C16.6716 18.0202 17.4134 18.2806 18.029 18.6121C18.6604 18.9436 19.1655 19.3303 19.5443 19.7722C19.9389 20.2142 20.223 20.7035 20.3966 21.2401C20.586 21.7768 20.6807 22.3371 20.6807 22.9211C20.6807 23.4578 20.5939 23.9865 20.4203 24.5074C20.2467 25.0283 19.9941 25.5255 19.6627 25.999C19.347 26.4567 18.9524 26.875 18.4789 27.2538C18.0053 27.6168 17.4687 27.9167 16.8689 28.1535C15.7325 28.5954 13.941 28.8164 11.4945 28.8164H1.33751V28.2245H2.14249C2.50553 28.2245 2.8291 28.1929 3.11321 28.1298C3.39732 28.0667 3.63408 27.9246 3.82348 27.7036C4.02867 27.4827 4.17862 27.1591 4.27333 26.7329C4.38381 26.3068 4.43906 25.7306 4.43906 25.0046V11.1068C4.43906 10.3492 4.38381 9.75731 4.27333 9.33114C4.16284 8.90498 4.005 8.5893 3.79981 8.38411C3.59462 8.16313 3.34997 8.02897 3.06585 7.98162C2.78174 7.91848 2.47396 7.88691 2.14249 7.88691H1.33751V7.29501H10.6185C13.6016 7.29501 15.8587 7.8001 17.3898 8.81027C18.9366 9.82044 19.71 11.2331 19.71 13.0483C19.71 14.1373 19.3785 15.1081 18.7156 15.9604C18.0527 16.7969 17.082 17.4204 15.8035 17.8308ZM7.49325 27.2538C8.69283 27.5379 9.9003 27.68 11.1157 27.68C12.0785 27.68 12.9308 27.5616 13.6727 27.3248C14.4145 27.0881 15.0301 26.7724 15.5194 26.3778C16.0087 25.9674 16.3796 25.4939 16.6321 24.9572C16.8847 24.4048 17.011 23.8208 17.011 23.2052C17.011 22.5265 16.8768 21.8873 16.6085 21.2875C16.3401 20.6877 15.9219 20.1668 15.3536 19.7249C14.8012 19.2829 14.0988 18.9357 13.2465 18.6831C12.4099 18.4306 11.4234 18.3043 10.287 18.3043C9.62408 18.3043 9.06375 18.3122 8.60602 18.328C8.14828 18.3438 7.77736 18.3832 7.49325 18.4464V27.2538ZM7.49325 16.9785C7.88785 17.0574 8.3298 17.1205 8.8191 17.1679C9.32418 17.1994 9.87662 17.2152 10.4764 17.2152C12.5757 17.2152 14.083 16.8364 14.9985 16.0788C15.914 15.3211 16.3717 14.2715 16.3717 12.9299C16.3717 12.3143 16.2375 11.7303 15.9692 11.1779C15.7167 10.6096 15.3379 10.1203 14.8328 9.70996C14.3277 9.29957 13.6963 8.976 12.9387 8.73924C12.1969 8.4867 11.3287 8.36043 10.3344 8.36043C9.26105 8.36043 8.31401 8.47881 7.49325 8.71557V16.9785ZM30.6009 13.8532C31.6111 13.8532 32.5423 14.0505 33.3947 14.4451C34.247 14.8397 34.981 15.3764 35.5965 16.0551C36.2279 16.718 36.7172 17.5072 37.0644 18.4227C37.4275 19.3224 37.609 20.2773 37.609 21.2875C37.609 22.4713 37.4117 23.5525 37.0171 24.5311C36.6383 25.5097 36.1174 26.3541 35.4545 27.0644C34.7916 27.7589 34.026 28.3034 33.1579 28.698C32.2898 29.0768 31.3822 29.2662 30.4352 29.2662C29.4408 29.2662 28.5174 29.0611 27.6651 28.6507C26.8286 28.2403 26.1025 27.6879 25.4869 26.9934C24.8871 26.2989 24.4136 25.4939 24.0664 24.5784C23.7349 23.663 23.5692 22.7001 23.5692 21.69C23.5692 20.6482 23.7507 19.6617 24.1137 18.7305C24.4768 17.7834 24.974 16.9469 25.6053 16.2208C26.2367 15.4948 26.9785 14.9187 27.8308 14.4925C28.6832 14.0663 29.6065 13.8532 30.6009 13.8532ZM30.1037 14.895C29.646 14.895 29.204 14.9976 28.7779 15.2028C28.3517 15.3922 27.9729 15.7079 27.6414 16.1498C27.31 16.576 27.0416 17.1363 26.8365 17.8308C26.6313 18.5253 26.5287 19.3697 26.5287 20.3641C26.5287 21.3901 26.6313 22.3766 26.8365 23.3236C27.0574 24.2548 27.3652 25.0756 27.7598 25.7859C28.1544 26.4962 28.6358 27.0644 29.204 27.4906C29.7723 27.9167 30.4036 28.1298 31.0981 28.1298C31.6032 28.1298 32.0688 28.0351 32.495 27.8457C32.9369 27.6405 33.3158 27.3169 33.6314 26.875C33.9471 26.433 34.1918 25.8569 34.3654 25.1466C34.5548 24.4206 34.6495 23.5367 34.6495 22.4949C34.6495 21.4532 34.5469 20.4746 34.3417 19.5591C34.1365 18.6279 33.8366 17.8229 33.442 17.1442C33.0632 16.4497 32.5897 15.9051 32.0215 15.5106C31.469 15.1002 30.8298 14.895 30.1037 14.895ZM46.8426 13.8532C47.8528 13.8532 48.784 14.0505 49.6363 14.4451C50.4887 14.8397 51.2226 15.3764 51.8382 16.0551C52.4696 16.718 52.9589 17.5072 53.3061 18.4227C53.6691 19.3224 53.8507 20.2773 53.8507 21.2875C53.8507 22.4713 53.6534 23.5525 53.2588 24.5311C52.8799 25.5097 52.3591 26.3541 51.6961 27.0644C51.0332 27.7589 50.2677 28.3034 49.3996 28.698C48.5315 29.0768 47.6239 29.2662 46.6769 29.2662C45.6825 29.2662 44.7591 29.0611 43.9068 28.6507C43.0702 28.2403 42.3442 27.6879 41.7286 26.9934C41.1288 26.2989 40.6553 25.4939 40.308 24.5784C39.9766 23.663 39.8108 22.7001 39.8108 21.69C39.8108 20.6482 39.9924 19.6617 40.3554 18.7305C40.7184 17.7834 41.2156 16.9469 41.847 16.2208C42.4783 15.4948 43.2202 14.9187 44.0725 14.4925C44.9248 14.0663 45.8482 13.8532 46.8426 13.8532ZM46.3454 14.895C45.8877 14.895 45.4457 14.9976 45.0195 15.2028C44.5934 15.3922 44.2146 15.7079 43.8831 16.1498C43.5516 16.576 43.2833 17.1363 43.0781 17.8308C42.8729 18.5253 42.7703 19.3697 42.7703 20.3641C42.7703 21.3901 42.8729 22.3766 43.0781 23.3236C43.2991 24.2548 43.6069 25.0756 44.0015 25.7859C44.3961 26.4962 44.8775 27.0644 45.4457 27.4906C46.0139 27.9167 46.6453 28.1298 47.3398 28.1298C47.8449 28.1298 48.3105 28.0351 48.7367 27.8457C49.1786 27.6405 49.5574 27.3169 49.8731 26.875C50.1888 26.433 50.4334 25.8569 50.6071 25.1466C50.7965 24.4206 50.8912 23.5367 50.8912 22.4949C50.8912 21.4532 50.7886 20.4746 50.5834 19.5591C50.3782 18.6279 50.0783 17.8229 49.6837 17.1442C49.3049 16.4497 48.8314 15.9051 48.2631 15.5106C47.7107 15.1002 47.0715 14.895 46.3454 14.895ZM60.2668 6.25328V20.6719L63.9839 17.3573C64.3154 17.0416 64.5758 16.7891 64.7652 16.5996C64.9704 16.4102 65.1204 16.2524 65.2151 16.1261C65.3256 15.9999 65.3966 15.9051 65.4282 15.842C65.4597 15.7631 65.4755 15.6842 65.4755 15.6053C65.4755 15.3843 65.3887 15.2028 65.2151 15.0607C65.0415 14.9187 64.7495 14.8318 64.3391 14.8003V14.2794H70.6605V14.8003C70.2186 14.8161 69.8161 14.8555 69.4531 14.9187C69.1058 14.966 68.7744 15.0528 68.4587 15.1791C68.1588 15.3054 67.8589 15.479 67.559 15.7C67.2591 15.9051 66.9355 16.1656 66.5883 16.4813L62.8712 19.9379L66.5883 24.6494C67.1092 25.3124 67.5432 25.849 67.8905 26.2594C68.2377 26.654 68.506 26.9381 68.6954 27.1117C68.9322 27.3485 69.1295 27.5379 69.2873 27.68C69.461 27.822 69.6425 27.9404 69.8319 28.0351C70.0213 28.114 70.2344 28.1693 70.4711 28.2008C70.7079 28.2324 71.0157 28.2482 71.3945 28.2482V28.8164H64.3391V28.2482C64.7495 28.2324 65.0257 28.1693 65.1677 28.0588C65.3098 27.9483 65.3808 27.7905 65.3808 27.5853C65.3808 27.3643 65.1677 26.9776 64.7416 26.4251L60.2668 20.7666V25.5491C60.2668 26.0384 60.2826 26.433 60.3142 26.7329C60.3457 27.017 60.3931 27.2459 60.4562 27.4195C60.5352 27.5932 60.622 27.7273 60.7167 27.822C60.8114 27.9009 60.9219 27.972 61.0481 28.0351C61.1744 28.114 61.3638 28.1693 61.6164 28.2008C61.8847 28.2166 62.224 28.2324 62.6344 28.2482V28.8164H55.2239V28.2482C55.7132 28.2482 56.1157 28.2166 56.4313 28.1535C56.747 28.0903 56.9917 27.9641 57.1653 27.7747C57.3547 27.5853 57.481 27.3248 57.5441 26.9934C57.6072 26.6461 57.6388 26.1884 57.6388 25.6202V12.409C57.6388 11.5567 57.6309 10.878 57.6151 10.3729C57.5993 9.85201 57.5757 9.50477 57.5441 9.33114C57.4652 8.93654 57.3389 8.66822 57.1653 8.52616C56.9917 8.38411 56.7707 8.31308 56.5024 8.31308C56.2814 8.31308 55.9499 8.40778 55.508 8.59719L55.2239 8.02897L59.5565 6.25328H60.2668Z"
                    fill="black"
                  />
                  <rect
                    x="74.8242"
                    y="2.84766"
                    width="88.3443"
                    height="32.5592"
                    rx="16.2796"
                    fill="#3F78E0"
                  />
                  <path
                    d="M95.648 6.79025V14.2245H95.0561C94.7878 12.2199 94.1327 10.6889 93.091 9.63135C92.0493 8.57383 90.7234 8.04507 89.1135 8.04507C88.561 8.04507 88.0559 8.13977 87.5982 8.32918C87.1405 8.51859 86.738 8.77113 86.3907 9.08681C86.0435 9.3867 85.7751 9.73395 85.5857 10.1285C85.3963 10.5231 85.3016 10.9335 85.3016 11.3597C85.3016 11.7543 85.3806 12.1331 85.5384 12.4961C85.6962 12.8434 86.1855 13.3958 87.0063 14.1535C88.3795 15.0216 89.6028 15.7397 90.6761 16.308C91.6862 16.8604 93.0515 17.6969 94.772 18.8176C95.5138 19.3858 96.0821 20.0645 96.4767 20.8537C96.8713 21.6271 97.0686 22.44 97.0686 23.2923C97.0686 24.0973 96.9028 24.8628 96.5714 25.5889C96.2399 26.315 95.7743 26.9542 95.1745 27.5067C94.5905 28.0433 93.8802 28.4695 93.0437 28.7852C92.2071 29.1166 91.2916 29.2824 90.2972 29.2824C89.6659 29.2824 89.0819 29.235 88.5452 29.1403C88.4505 29.1245 88.198 29.0535 87.7876 28.9272C87.393 28.8167 86.9668 28.6983 86.5091 28.5721C86.0514 28.4458 85.6252 28.3274 85.2306 28.2169C84.836 28.1064 84.6071 28.0512 84.544 28.0512C84.2757 28.0512 84.0626 28.1301 83.9048 28.288C83.7627 28.4458 83.6522 28.7773 83.5733 29.2824H82.9814V21.8955H83.5733C83.8574 23.4107 84.2283 24.5708 84.6861 25.3758C84.907 25.7546 85.199 26.1098 85.5621 26.4412C85.9409 26.7569 86.3592 27.041 86.8169 27.2936C87.2904 27.5303 87.7955 27.7197 88.3321 27.8618C88.8688 27.9881 89.4133 28.0512 89.9658 28.0512C90.6287 28.0512 91.2206 27.9565 91.7415 27.7671C92.2781 27.5777 92.728 27.3251 93.091 27.0095C93.4698 26.678 93.7539 26.2992 93.9433 25.873C94.1485 25.4469 94.2511 24.997 94.2511 24.5235C94.2511 23.9868 94.1012 23.4502 93.8013 22.9135C93.5172 22.3769 93.0279 21.8481 92.3334 21.3272C91.6547 20.9169 90.8497 20.4355 89.9184 19.883C88.1348 18.8571 86.5486 17.8706 85.1596 16.9235C84.3862 16.308 83.7943 15.6371 83.3839 14.9111C82.9893 14.1692 82.792 13.3485 82.792 12.4488C82.792 11.6912 82.9498 10.973 83.2655 10.2943C83.5812 9.59979 84.0152 8.99211 84.5677 8.47124C85.1359 7.95037 85.8067 7.53998 86.5801 7.24009C87.3535 6.94019 88.1901 6.79025 89.0898 6.79025C90.2262 6.79025 91.4337 7.06647 92.7122 7.6189C93.0121 7.74517 93.2646 7.84777 93.4698 7.92669C93.675 8.00561 93.8407 8.03718 93.967 8.02139C94.2511 8.02139 94.48 7.94247 94.6536 7.78463C94.8272 7.6268 94.9614 7.29533 95.0561 6.79025H95.648ZM112.126 28.7852L103.816 10.6968V25.068C103.816 25.8099 103.864 26.3939 103.958 26.8201C104.069 27.2304 104.219 27.5382 104.408 27.7434C104.613 27.9486 104.858 28.0749 105.142 28.1222C105.426 28.1696 105.75 28.1933 106.113 28.1933H106.87V28.7852H99.3888V28.1933H100.146C100.525 28.1933 100.857 28.1696 101.141 28.1222C101.425 28.0591 101.662 27.9249 101.851 27.7197C102.04 27.4988 102.183 27.1831 102.277 26.7727C102.372 26.3465 102.419 25.7783 102.419 25.068V11.0046C102.419 10.4995 102.396 10.0575 102.348 9.67871C102.301 9.28411 102.175 8.95265 101.969 8.68432C101.78 8.41599 101.48 8.2108 101.07 8.06875C100.675 7.92669 100.115 7.85566 99.3888 7.85566V7.26376H105.473L113.287 24.0973L120.958 7.26376H127.042V7.85566H126.308C125.914 7.85566 125.574 7.88723 125.29 7.95037C125.006 8.0135 124.769 8.15556 124.58 8.37653C124.391 8.58172 124.248 8.8974 124.154 9.32357C124.059 9.73395 124.012 10.2943 124.012 11.0046V25.068C124.012 25.8099 124.059 26.3939 124.154 26.8201C124.264 27.2304 124.414 27.5382 124.604 27.7434C124.809 27.9486 125.053 28.0749 125.338 28.1222C125.622 28.1696 125.945 28.1933 126.308 28.1933H127.042V28.7852H117.903V28.1933H118.661C119.04 28.1933 119.371 28.1617 119.655 28.0986C119.939 28.0354 120.176 27.9013 120.366 27.6961C120.571 27.4751 120.721 27.1594 120.815 26.749C120.91 26.3386 120.958 25.7783 120.958 25.068V10.6968L112.671 28.7852H112.126ZM141.011 28.7852L132.701 10.6968V25.068C132.701 25.8099 132.748 26.3939 132.843 26.8201C132.953 27.2304 133.103 27.5382 133.293 27.7434C133.498 27.9486 133.743 28.0749 134.027 28.1222C134.311 28.1696 134.634 28.1933 134.997 28.1933H135.755V28.7852H128.273V28.1933H129.031C129.41 28.1933 129.741 28.1696 130.025 28.1222C130.31 28.0591 130.546 27.9249 130.736 27.7197C130.925 27.4988 131.067 27.1831 131.162 26.7727C131.257 26.3465 131.304 25.7783 131.304 25.068V11.0046C131.304 10.4995 131.28 10.0575 131.233 9.67871C131.186 9.28411 131.059 8.95265 130.854 8.68432C130.665 8.41599 130.365 8.2108 129.954 8.06875C129.56 7.92669 128.999 7.85566 128.273 7.85566V7.26376H134.358L142.171 24.0973L149.842 7.26376H155.927V7.85566H155.193C154.798 7.85566 154.459 7.88723 154.175 7.95037C153.891 8.0135 153.654 8.15556 153.465 8.37653C153.275 8.58172 153.133 8.8974 153.038 9.32357C152.944 9.73395 152.896 10.2943 152.896 11.0046V25.068C152.896 25.8099 152.944 26.3939 153.038 26.8201C153.149 27.2304 153.299 27.5382 153.488 27.7434C153.693 27.9486 153.938 28.0749 154.222 28.1222C154.506 28.1696 154.83 28.1933 155.193 28.1933H155.927V28.7852H146.788V28.1933H147.546C147.924 28.1933 148.256 28.1617 148.54 28.0986C148.824 28.0354 149.061 27.9013 149.25 27.6961C149.455 27.4751 149.605 27.1594 149.7 26.749C149.795 26.3386 149.842 25.7783 149.842 25.068V10.6968L141.556 28.7852H141.011Z"
                    fill="white"
                  />
                </svg>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: "space-between",
                  marginBottom: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      lineHeight: "28px",
                      fontSize: "18px",
                      color: "#004571",
                    }}
                  >
                    Invoice
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: "400",
                      lineHeight: "28px",
                      fontSize: "18px",
                      color: "#004571",
                    }}
                  >
                    #{invoice.invoice_id}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      lineHeight: "28px",
                      fontSize: "18px",
                      color: "#474747",
                    }}
                  >
                    Date
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: "400",
                      lineHeight: "28px",
                      fontSize: "18px",
                      color: "#474747",
                    }}
                  >
                    {invoice.created_at}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                borderBottom: "1px solid #5F5F5F",
                paddingRight: { sm: 0, md: "50px" },
                gap: "50px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: { xs: "center", md: "space-between" },
                  marginTop: "30px",
                  gap: { xs: "20px", md: 0 },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    gap: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: "18px",
                      lineHeight: "28px",
                      color: "#474747",
                    }}
                  >
                    From
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      width: { xs: "100%", md: "40%" },
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#474747",
                        fontWeight: "600",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      BOOKSMM
                    </Typography>
                    <Typography>info@booksmm.com</Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    gap: "10px",
                    marginRight: "40px",
                    width: "50%",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: "18px",
                      lineHeight: "28px",
                      color: "#474747",
                    }}
                  >
                    To
                  </Typography>
                  <Box sx={{}}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#474747",
                          fontWeight: "600",
                          fontSize: "16px",
                          lineHeight: "24px",
                        }}
                      >
                        {invoice.user_name}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#474747",
                          fontWeight: "600",
                          fontSize: "16px",
                          lineHeight: "24px",
                        }}
                      >
                        Panel URL
                      </Typography>
                      <Typography
                        sx={{
                          color: "#3F78E0",
                          fontWeight: "300",
                          fontSize: "#3F78E0",
                        }}
                      >
                        {invoice.panel_url}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: { xs: "center", md: "space-between" },
                  alignItems: { xs: "center", md: "normal" },
                  gap: { xs: "20px", md: 0 },
                }}
              >
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "10px" }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: "18px",
                      lineHeight: "28px",
                      color: "#474747",
                    }}
                  >
                    Service Details
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "16px",
                        lineHeight: "24px",
                        fontWeight: "500",
                        color: "#474747",
                      }}
                    >
                      {invoice.offer_title}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        lineHeight: "18px",
                        fontWeight: "400",
                        color: "#474747",
                        marginLeft: "10px",
                        width: { xs: "100%", md: "100%" },
                      }}
                    >
                      {invoice.offer_details?.length > 0 && (
                        <ul style={{ width: "100%" }}>
                          {invoice.offer_details.map((detail, index) => (
                            <li style={{ width: "100%" }} key={index}>
                              {detail.detail}
                            </li>
                          ))}
                        </ul>
                      )}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ width: { xs: "100%", md: "50%" } }}>
                  <Box
                    sx={{
                      background: "#D2E2EC",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      width: "50%",
                      margin: "auto",
                      padding: "20px 40px",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#303030",
                        fontSize: "13px",
                        fontWeight: "300",
                        lineHeight: "16px",
                      }}
                    >
                      price
                    </Typography>
                    <Typography
                      sx={{
                        color: "#303030",
                        fontSize: "13px",
                        fontWeight: "300",
                        lineHeight: "16px",
                      }}
                    >
                      {!invoice.custom && `${invoice.offer_total_price}$`}
                      {invoice.custom && `${invoice.price}$`}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      background: "#D2E2EC",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      width: "50%",
                      margin: "auto",
                      padding: "20px 40px",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#303030",
                        fontSize: "14px",
                        fontWeight: "500",
                        lineHeight: "18px",
                      }}
                    >
                      Discount
                    </Typography>
                    <Typography
                      sx={{
                        color: "#303030",
                        fontSize: "14px",
                        fontWeight: "500",
                        lineHeight: "18px",
                      }}
                    >
                      {invoice.custom && `${invoice.offer_discount}$`}
                      {!invoice.custom && `${invoice.offer_discount}%`}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      background: "#296D99",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      width: "50%",
                      margin: "auto",
                      padding: "20px 40px",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#FFFFFF",
                        fontSize: "18px",
                        fontWeight: "500",
                        lineHeight: "20px",
                      }}
                    >
                      Final Price
                    </Typography>
                    <Typography
                      sx={{
                        color: "#FFFFFF",
                        fontSize: "18px",
                        fontWeight: "500",
                        lineHeight: "20px",
                      }}
                    >
                      {invoice.custom && `${invoice.offer_total_price}$`}
                      {!invoice.custom && `${invoice.price}$`}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ mb: 4 }}>
                <Typography variant="h6" gutterBottom>
                  Payment Methods
                </Typography>
                <Typography paragraph>
                  Please select one payment method below.
                </Typography>

                <Box sx={{ mb: 3 }}>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Radio
                      checked={payment_method === "cryptomus"}
                      onChange={handleMethodChange}
                      value="cryptomus"
                      color="primary"
                    />
                    <img
                      src={Crtypto}
                      alt="Cryptomus"
                      style={{ height: 24, marginRight: 8 }}
                    />
                    <Typography>Cryptomus</Typography>
                  </Box>

                  {/*<Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>*/}
                  {/*  <Radio*/}
                  {/*      checked={paymentMethod === "paypal"}*/}
                  {/*      onChange={handleMethodChange}*/}
                  {/*      value="paypal"*/}
                  {/*      color="primary"*/}
                  {/*  />*/}
                  {/*  <img src={Paypal} alt="PayPal" style={{ height: 24, marginRight: 8 }} />*/}
                  {/*  <Typography>PayPal</Typography>*/}
                  {/*</Box>*/}

                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Radio
                      checked={payment_method === "payeer"}
                      onChange={handleMethodChange}
                      value="payeer"
                      color="primary"
                    />
                    <img
                      src={Payeer}
                      alt="Payeer"
                      style={{ height: 24, marginRight: 8 }}
                    />
                    <Typography>Payeer</Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Radio
                      checked={payment_method === "manually"}
                      onChange={handleMethodChange}
                      value="manually"
                      color="primary"
                    />
                    <AttachMoneyIcon style={{ height: 24, marginRight: 8 }} />
                    <Typography>Manual</Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
              <Button
                variant="outlined"
                onClick={printInvoice}
                sx={{ "@media print": { display: "none" } }}
              >
                Print Invoice
              </Button>

              {payment_method && (
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={IsloadingForBuy}
                  sx={{ "@media print": { display: "none" } }}
                >
                  {IsloadingForBuy ? (
                    <>
                      <CircularProgress size={24} sx={{ mr: 1 }} />
                      Processing...
                    </>
                  ) : (
                    "Buy Now"
                  )}
                </Button>
              )}
            </Box>
          </Box>
        </Container>
      )}
    </>
  );
};
export default OffersInvoiceByGuest;
